export default __webpack_public_path__ + "static/media/29.60ec2c88.jpg";